const USER_LOGGED_IN_ON_MULTIPLE_DEVICES_ERROR_CODE = 'user logged in on multiple devices'
const FAILED_TO_AUTHENTICATE_USER = 'failed to authenticate user'

export { USER_LOGGED_IN_ON_MULTIPLE_DEVICES_ERROR_CODE, FAILED_TO_AUTHENTICATE_USER }